



















































































import { defineComponent, ref, computed } from '@vue/composition-api';
import { Message } from 'byted-vui';
import { StateEnum, useStdAccountStore, useStore } from '@tt4b/ttam-hooks';
import ThumbsUpIcon from '@tt4b/ttam-assets/src/svgs/thumbs-up.svg';
import ThumbsUpBlueIcon from '@tt4b/ttam-assets/src/svgs/thumbs-up-blue.svg';
import { i18n } from './../../../i18n';
import { trackEvent } from './../../../utils/index';
import { getCurrentLang } from '@tt4b/ttam-utils';

const genVoteOptions = () => [
  { value: 'vote_selection_1', label: i18n.t('module_vote_feedback_reason_no_violate') },
  { value: 'vote_selection_2', label: i18n.t('module_vote_feedback_reason_similar_pass') },
  { value: 'vote_selection_3', label: i18n.t('module_vote_feedback_reason_other_platform_pass') },
  { value: 'vote_selection_4', label: i18n.t('module_vote_feedback_reason_not_native') },
  { value: 'vote_selection_5', label: i18n.t('module_vote_feedback_reason_too_vague') },
  { value: 'vote_selection_6', label: i18n.t('module_vote_feedback_reason_no_specify_area') },
];

const name = 'ttam-audit-reject-side-vote';

export default defineComponent({
  name,
  components: {
    ThumbsUpIcon,
    ThumbsUpBlueIcon,
  },
  props: {
    reason: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const popoverVisible = ref(false);
    const btnLoading = ref(false);
    const selectedOptions = ref<string[]>([]);
    const reasonText = ref('');
    const isShowVoteForAudit = ref(true);
    const { state } = useStore();

    const dataTeaParamsReason = computed(() => {
      const { suggestion = '', reasons = [] } = props.reason;

      return {
        suggestion,
        reasons: reasons.join(','),
      };
    });

    const trackEventParams = computed(() => {
      const { accountInfo } = useStdAccountStore();
      const aadvid = computed(() => state[StateEnum.baseInfo].value.aadvid);
      return {
        advertiser_origin: accountInfo.value.account?.customer_type_value,
        language: getCurrentLang(),
        adv_id: aadvid.value,
        adgroup_id: props.reason.adgroupId,
        cid: props.reason.cid || '-',
        disapproval_code: props.reason.disapprovalCode || '-',
      };
    });

    const handlePopoverHide = () => {
      selectedOptions.value = [];
    };

    const handleThumbsUp = () => {
      trackEvent('audit_reject_suggestion_feedback', {
        module_vote_helpful_tip: 1,
        module_vote_not_helpful_tip: 0,
        ...dataTeaParamsReason.value,
        ...trackEventParams.value,
      });
      Message.success(i18n.t('module_vote_feedback_not_help_msg') as string);
      isShowVoteForAudit.value = false;
    };

    const voteSelectionValue = key => (selectedOptions.value.includes(key) ? 1 : 0);

    const handleReport = () => {
      btnLoading.value = true;

      const params = {
        module_vote_feedback_reason_no_violate: voteSelectionValue('vote_selection_1'),
        module_vote_feedback_reason_similar_pass: voteSelectionValue('vote_selection_2'),
        module_vote_feedback_reason_other_platform_pass: voteSelectionValue('vote_selection_3'),
        module_vote_feedback_reason_not_native: voteSelectionValue('vote_selection_4'),
        module_vote_feedback_reason_too_vague: voteSelectionValue('vote_selection_5'),
        module_vote_feedback_reason_no_specify_area: voteSelectionValue('vote_selection_6'),
        feedback: reasonText.value,
      };

      trackEvent('audit_reject_suggestion_feedback', {
        module_vote_helpful_tip: 0,
        module_vote_not_helpful_tip: 1,
        ...params,
        ...trackEventParams.value,
        ...dataTeaParamsReason.value,
      });

      popoverVisible.value = false;
      btnLoading.value = false;
      isShowVoteForAudit.value = false;
      Message.success(i18n.t('module_vote_feedback_not_help_msg') as string);
    };

    const handleAction = type => {
      if (type === 'cancel') {
        popoverVisible.value = false;
      }
      if (type === 'report') {
        handleReport();
      }
    };

    return {
      name,
      VOTE_OPTIONS: computed(() => genVoteOptions()),
      popoverVisible,
      btnLoading,
      reasonText,
      selectedOptions,
      handleReport,
      isShowVoteForAudit,
      handleThumbsUp,
      handleAction,
      handlePopoverHide,
    };
  },
});
